import "./TableComp.css";
import { defineComponent as q, useCssVars as L, computed as f, ref as C, watch as D, openBlock as o, createElementBlock as s, createElementVNode as u, Fragment as _, renderList as m, normalizeClass as p, toDisplayString as k, createBlock as P, createCommentVNode as R, renderSlot as z } from "vue";
import { IconComp as A } from "./IconComp.js";
import { i as d } from "./isNil.6f60d6a4.js";
import { i as y } from "./isEqual.398c54af.js";
import { s as E, a as K, b as V } from "./sort.779f43d3.js";
import { _ as $ } from "./_plugin-vue_export-helper.dad06003.js";
const j = { class: "table" }, G = { class: "table__table" }, J = { class: "table__headersRow" }, M = ["onClick", "disabled"], O = /* @__PURE__ */ q({
  __name: "TableComp",
  props: {
    headers: {
      type: Array,
      required: !0
    },
    items: {
      type: Array,
      required: !0
    },
    /**
     * Used for the v-for loop key to help vue not reload the div everytime the order changes, default is the index of the list
     */
    uniqueKeyIdentifier: {
      type: String,
      default: void 0
    },
    pageNumber: {
      type: Number,
      default: void 0
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    filteringProperty: {
      type: String,
      default: null
    },
    filteringTerm: {
      type: String,
      default: null
    },
    sortFunction: {
      type: Function,
      default: null
    },
    defaultHeaderSortingTo: {
      type: String,
      default: null
    },
    stickyFirstColumn: Boolean,
    tableDataHeight: {
      type: String,
      default: "60px"
    }
  },
  setup(b, { expose: B }) {
    L((t) => ({
      "2b97a5c8": b.tableDataHeight
    }));
    const e = b, g = f(() => e.headers.find((l) => l.value === e.defaultHeaderSortingTo) ?? null), a = C(
      d(e.defaultHeaderSortingTo) ? null : g.value
    ), c = C(!0);
    D(
      () => e.defaultHeaderSortingTo,
      () => {
        a.value = g.value;
      }
    );
    function h(t) {
      return {
        table__headerBox: !0,
        "table__headerBox--selected": y(t, a.value),
        "table__headerBox--flipArrow": y(t, a.value) && !c.value
      };
    }
    function F(t) {
      y(t, a.value) ? (c.value = !c.value, a.value = t) : (c.value = !0, a.value = t);
    }
    const w = f(() => ({
      table__tableBody: !0,
      "table__tableBody--sticky": e.stickyFirstColumn
    })), x = f(() => ({
      table__tableRow: !0,
      "table__tableRow--sticky": e.stickyFirstColumn
    })), N = f(() => {
      let t = [...e.items];
      return !d(e.filteringProperty) && !d(e.filteringTerm) && (t = T(t)), d(a.value) || (t = v(t)), e.pageNumber && e.pageSize && (t = t.slice(0, e.pageNumber * e.pageSize)), t;
    });
    function T(t) {
      return t.filter(
        (l) => d(l[e.filteringProperty]) ? !1 : l[e.filteringProperty].toString().toLowerCase().includes(e.filteringTerm)
      );
    }
    function v(t) {
      var i, n, S;
      let l;
      e.sortFunction && typeof e.sortFunction == "function" ? l = e.sortFunction : (i = a.value) != null && i.sortByDates ? l = E : (n = a.value) != null && n.sortByNumbers ? l = K : l = V;
      const r = ((S = a.value) == null ? void 0 : S.value) || "";
      return t.sort(
        (H, I) => l(H[r], I[r], c.value)
      );
    }
    return B({
      sortItemList: v
    }), (t, l) => (o(), s("div", j, [
      u("table", G, [
        u("thead", null, [
          u("tr", J, [
            (o(!0), s(_, null, m(e.headers, (r, i) => (o(), s("th", {
              key: r.value,
              class: p({
                "table__headerBox--sticky": e.stickyFirstColumn && i === 0
              })
            }, [
              u("button", {
                onClick: (n) => F(r),
                disabled: r.disableSorting,
                class: p(h(r))
              }, [
                u("p", null, k(r.text), 1),
                r.disableSorting ? R("", !0) : (o(), P(A, {
                  key: 0,
                  icon: "arrow_upward_small"
                }))
              ], 10, M)
            ], 2))), 128))
          ])
        ]),
        u("tbody", {
          class: p(w.value)
        }, [
          (o(!0), s(_, null, m(N.value, (r, i) => (o(), s("tr", {
            class: p(x.value),
            key: e.uniqueKeyIdentifier ? r[e.uniqueKeyIdentifier] : i
          }, [
            z(t.$slots, "tableRow", { item: r }, () => [
              (o(!0), s(_, null, m(e.headers, (n) => (o(), s("td", {
                key: r[n.value]
              }, k(r[n.value]), 1))), 128))
            ], !0)
          ], 2))), 128))
        ], 2)
      ])
    ]));
  }
});
const te = /* @__PURE__ */ $(O, [["__scopeId", "data-v-12e7dbea"]]);
export {
  te as TableComp
};
//# sourceMappingURL=TableComp.js.map
